"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm2.68,7.9a.25.25,0,0,1-.25.25H8.86v4.33h5.22a.25.25,0,0,1,.25.25v1.36a.25.25,0,0,1-.25.25H8.86v5.39a.25.25,0,0,1-.25.25H7.08a.25.25,0,0,1-.25-.25V6.54a.25.25,0,0,1,.25-.25h7.35a.25.25,0,0,1,.25.25Zm2.82,2.6a2,2,0,1,1,2-2A2,2,0,0,1,17.5,10.5Z"
  }));
};

exports["default"] = _default;